import { ErrorWrapper } from './util'

import { OdooService } from './odoo.service'

const MODEL = 'x_class'
// const DOMAIN = {}
const BASIC_FIELDS = ['x_neptuno_id', 'x_name', 'x_year', 'x_capacity', 'x_comment', 'x_comment_date', 'x_comment_user', 'x_advanced_class', 'x_room_id', 'x_product_template_id', 'x_teacher_id', 'x_year_id', 'x_class_comment_ids', 'x_enrollments_ids']
const OPTS = { limit: 50, order: 'x_name desc' }

export class ClassesService extends OdooService {
  // eslint-disable-next-line no-useless-constructor
  constructor () {
    super()
  }

  static get entity () {
    return 'fields'
  }

  static async read (ids, fields = []) {
    try {
      return await this.kwRead(MODEL, ids, [...BASIC_FIELDS, ...fields])
    } catch (error) {
      console.log(error)
    }
  }

  static async list (domain = {}) {
    // console.log('searching classes ', domain)
    try {
      return await this.kwSearchRead(MODEL, domain, BASIC_FIELDS, OPTS)
    } catch (error) {
      console.log(error)
      throw new ErrorWrapper(error)
    }
  }

  static async create (data) {
    try {
      if (data.x_year_id) {
        const x_year = await this.kwSearchRead('x_year', { id: data.x_year_id }, ['x_year'])
        data.x_year = x_year[0].x_year
      }
      return await this.kwCreate(MODEL, data)
    } catch (error) {
      console.log(error)
      throw new ErrorWrapper(error)
    }
  }

  static async delete (id) {
    try {
      return await this.kwDelete(MODEL, id)
    } catch (error) {
      console.log(error)
      throw new ErrorWrapper(error)
    }
  }

  static async update (id, data) {
    try {
      // console.log(data)
      return await this.kwUpdate(MODEL, id, data)
    } catch (error) {
      // console.log(error)
      throw new ErrorWrapper(error)
    }
  }

  static async listWithCancelled (domain = {}) {
    // console.log('searching classes ', domain)
    try {
      const classes = await this.kwSearchRead(MODEL, domain, BASIC_FIELDS, OPTS)
      const promises = classes.map(async item => {
        item.x_cancelled = await this.getCancelledEnrollmentsCount(item.x_enrollments_ids)
      })
      await Promise.all(promises)
      return classes
    } catch (error) {
      console.log(error)
      throw new ErrorWrapper(error)
    }
  }

  static async getCancelledEnrollmentsCount (enrollmentsIds) {
    try {
      const enrollmentStatus = await this.kwRead('x_enrollment', enrollmentsIds, ['id', 'x_status'])
      return enrollmentStatus.filter(i => i.x_status === 'canceled').length
    } catch (error) {
      // console.log(error)
      throw new ErrorWrapper(error)
    }
  }
}
